module.exports = __webpack_public_path__ + "img/logo.e627f979.png";